import React ,{useEffect,useState}from 'react';
import OduLandingPage from '../../../features/odu/components/OduLandingPage';

const OduComponent =()=>{
    const [deviceDetails,setDeviceDetails]=useState({})

    useEffect(()=>{
        let details=sessionStorage.getItem('devices_detail');
        if(details){
            details=JSON.parse(details);
            setDeviceDetails(details);
        }
    },[])
    

    return (<>
    {!!Object.entries(deviceDetails)?.length && <OduLandingPage deviceDetails={deviceDetails}/>}
    </>)
}

export default OduComponent;
